import { Variants } from 'framer-motion'

// Shared, subtle spring-based motion — banking-appropriate, not bouncy.
export const spring = { type: 'spring', stiffness: 120, damping: 18 } as const

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: spring },
}

export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
}

// ponytail: 'some' not a ratio — tall containers (timeline on mobile) can never hit 20% visible and stay hidden
export const viewportOnce = { once: true, amount: 'some', margin: '0px 0px -10% 0px' } as const

export const cardHover = {
  whileHover: { y: -4, scale: 1.02 },
  whileTap: { scale: 0.98 },
  transition: spring,
}

export const wiggle = {
  whileHover: { rotate: [0, -8, 8, -4, 0] },
  transition: { duration: 0.4 },
}
